import React, { useEffect, useState } from "react";
import {
  TextField,
  Button,
  FormControl,
  Container,
  Grid,
  Box,
  Stack,
  OutlinedInput,
  InputLabel,
  MenuItem,
  ListItemText,
  Select,
  Checkbox,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormLabel,
  Modal,
  Divider,
} from "@mui/material";
// import "./test.css";

import dayjs from "dayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
// import { bookApoinment } from "./asppoinmentApi";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import { routePath } from "../../constants/routePath";
import { setSession } from "../../utils/commonUtils";
import { setCustomerAppointmentId } from "../../app/store/reducer";
// import dayjs from 'dayjs';
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import { getAlldetailSerice } from "../services/servicesListApi";
import EmployeeModal from "../../common/employeeModel";
import { addOffer, updateOffer } from "./apiFunction";
import ImageUploadButton from "../../common/imgUpload";
import { ModalHeader } from "../../common/modalHeader";
dayjs.extend(utc);
dayjs.extend(timezone);

const PopUp = ({ open, setOpen, data, callbackGetMsg }) => {
  const struct = {
    billerId: "",
    customerName: "",
    mobileNumber: "",
    // otp: "",
    mailId: "",
    gender: "",
    service: "",
    date: "",
    hour: "",
    minute: "",
    status: "Unassigned",
    employeeId: "",
  };
  const [formData, setFormData] = useState({ ...struct });
  const handle = (e) => {
    e.preventDefault();
    if (data) {
      updateOffer({ message: formData.customerName, id: data?.id }, (data) => {
        // alert('ioni')
        setOpen(false);
        callbackGetMsg();
      });
    } else {
      addOffer({ message: formData.customerName }, (data) => {
        // alert('ioni')
        setOpen(false);
        callbackGetMsg();
      });
    }
  };
  useEffect(() => {
    if (open == true) {
      console.log("Data", data);

      if (data) {
        setFormData({ ...formData, customerName: data?.message });
      }
    } else {
      setFormData(struct);
    }
  }, [open]);

  return (
    <Modal
      open={open}
      onClose={() => {
        setOpen(false);
      }}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        sx={{
          background: "white",
          width: { xs: "95%", sm: "40%", md: "40%", lg: "40%" },

          overflowY: "auto",
          height: { md: "65vh", sm: "60vh", xs: "58vh" },
          borderRadius: "10px",
          position: "absolute",
          left: { xs: "2%", sm: "25%", md: "30%", lg: "30%" },

          top: "12%",
        }}
      >
        <ModalHeader
          title={"Bulk Message"}
          onClose={(data) => {
            setOpen(data);
          }}
        />
        <Container>
          <Box display="flex" justifyContent="center">
            <form onSubmit={handle} style={{ width: "100%" }}>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={12}>
                  <FormControl fullWidth margin="normal">
                    <TextField
                      label="Enter Message"
                      name="customerName"
                      value={formData.customerName}
                      onChange={(e) => {
                        setFormData({
                          ...formData,
                          customerName: e.target.value,
                        });
                      }}
                      required
                      multiline // Makes the TextField act as a textarea
                      rows={14} // Number of rows (you can adjust this)
                      InputLabelProps={{
                        className: "mulish",
                        sx: {
                          fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        },
                      }}
                      InputProps={{
                        classes: { input: "mulish" },

                        sx: {
                          fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        },
                      }}
                    />
                  </FormControl>
                </Grid>

                <Grid item xs={12}>
                  <Divider
                    sx={{
                      backgroundColor: "#4E4E4E",
                      height: "0.5px",
                      marginX: "-24px",
                    }}
                  />
                </Grid>

                <Grid item xs={12} sx={{ paddingX: "40px !important" }}>
                  <Button
                    type="submit"
                    variant="contained"
                    fullWidth
                    sx={{
                      backgroundColor: "#01008B",
                      fontSize: { xs: "12px", sm: "13px", md: "18px" },
                    }}
                  >
                    {data?.id ? "Update" : "Save"}
                  </Button>
                </Grid>
              </Grid>
            </form>
          </Box>
        </Container>{" "}
      </Box>
    </Modal>
  );
};

export default PopUp;
